// lightgallery.js must come before lg-video otherwise an undefined error occurs
import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";

const vimeoAPIUrl = "https://player.vimeo.com/api/player.js";
const youtubeAPIUrl = "https://www.youtube.com/iframe_api";

const loadVimeoAPI = () => {
  if (
    !document.querySelector(".js-gallery-vimeo") ||
    document.querySelector(`script[src="${vimeoAPIUrl}"]`)
  ) {
    return;
  }

  const script = document.createElement("script");
  script.src = vimeoAPIUrl;
  document.head.appendChild(script);
};

const loadYoutubeAPI = () => {
  if (
    !document.querySelector(".js-gallery-youtube") ||
    document.querySelector(`script[src="${youtubeAPIUrl}"]`)
  ) {
    return;
  }

  const script = document.createElement("script");
  script.src = youtubeAPIUrl;
  document.head.appendChild(script);
};

const instance = ($el: HTMLElement) => {
  lightGallery($el, {
    getCaptionFromTitleOrAlt: false,
    licenseKey: "C84715AF-2344-4A59-AE51-BB3F712CFEF3",
    plugins: [lgVideo],
    selector: "a",
    videoMaxSize: "100%",
  });
};

export default () => {
  loadVimeoAPI();
  loadYoutubeAPI();

  document
    .querySelectorAll<HTMLElement>(".js-gallery")
    .forEach(($el: HTMLElement) => {
      instance($el);
    });
};
